//import { createSelector } from "reselect";

const USER_LOGGED_IN = "USER_LOGGED_IN";
const USER_LOGGED_OUT = "USER_LOGGED_OUT";
const USER_START_LOGIN = "USER_START_LOGIN";
const USER_LOGIN_ERROR = "USER_LOGIN_ERROR";

export function loggedIn(user) {
  //we need to load user settings from firebase! (settings will load always at login)
  return async (dispatch, getState) => {
    try {
      console.log("Logged in user", user);
      dispatch({ type: USER_LOGGED_IN, user });
    } catch (e) {
      dispatch({ type: USER_LOGIN_ERROR, error: e });
    }
  };
}

export function loggedOut() {
  return { type: USER_LOGGED_OUT };
}

const INIT_STATE = {
  details: {},
  logging_in: true,
  settings: {}
};

export const userReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case USER_START_LOGIN:
      return { ...state, logging_in: true };
    case USER_LOGGED_IN:
      return {
        ...state,
        isSignedIn: true,
        logging_in: false,
        details: action.user
      };
    case USER_LOGIN_ERROR:
      return {
        ...state,
        logging_in: false,
        isSignedIn: false,
        loginError: action.error
      };
    case USER_LOGGED_OUT:
      return {
        ...state,
        isSignedIn: false,
        logging_in: false,
        details: {}
      };

    default:
      return state;
  }
};

//selectors
export const isUserLoggedIn = state => state.user.isSignedIn;
export const isLoginStatusLoading = state => state.user.logging_in;
export const getUserName = state => state.user.details.displayName;
export const getUserUID = state => state.user.details.uid;
export const getCurrentSite = () => {
  const host = window.location.hostname;
  let site = "Auckland";
  if (host.indexOf("auckland") >= 0) {
    site = "Auckland";
  }
  return site;
};
